/** Just a fake element to test styles
 * @module mucss/fake-element
 */

module.exports = document.createElement('div');